export default __webpack_public_path__ + "static/media/lua.49e5ad6f.svg";